import { createSelector } from 'reselect'

const mobileAppSelector = state => state.mobile_app

export function fromMobileSelector() {
  return createSelector(mobileAppSelector, mobileApp => mobileApp.from_app)
}

export const canManageMobileSelector = createSelector(
  mobileAppSelector,
  mobileApp => mobileApp.can_manage
)

export const canShareMobileSelector = createSelector(
  mobileAppSelector,
  mobileApp => mobileApp.can_share
)
